import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import classes from "./styles/style.module.css";
import CustomModal from "../../../assets/components/ModalComonent";
import InfoImg from "../../../assets/images/common/InfoImg.png";
import {
  setRightAnswer,
  setShowCheatModal,
  setWrongAnswers,
} from "../../../assets/redux/actions/Quiz";
import CustomButton from "../../../assets/components/CustomButton";
import { GoStopwatch } from "react-icons/go";
import KeyIcon from "../../../assets/images/icons/YellowKeyIcon.svg";
import appApi from "../../../assets/utils/AppApi";
import Loading from "../../../assets/containers/loadingDialog";
import errorHandler from "../../../assets/utils/ErrorHandler";
import UsersRequests from "../../../assets/services/user";
import toast from "react-hot-toast";

export default function CheatModal() {
  const { showCheatModal } = useSelector(({ quiz }) => quiz);
  const { currentUser } = useSelector(({ user }) => user);
  const [selected, setselected] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { currentQuestion } = useSelector(({ quiz }) => quiz);

  const handleBuyTime = () => {
    if (selected === "first") {
      setLoading(true);
      appApi
        .post(`/quizCheat/create`, {
          type: "Time",
          ticketId: localStorage.getItem("Ticket"),
        })
        .then(({ data }) => {
          setLoading(false);
          toast.success(data.message);
          dispatch(setShowCheatModal(false));
          dispatch(UsersRequests.getme());
        })
        .catch((error) => {
          errorHandler(error);
          setLoading(false);
        });
    } else if (selected === "second") {
      setLoading(true);
      appApi
        .post(`/quizCheat/create`, {
          type: "RemoveWrongAnswer",
          questionId: currentQuestion?._id,
          ticketId: localStorage.getItem("Ticket"),
        })
        .then(({ data }) => {
          setLoading(false);
          toast.success(data.message);
          dispatch(setWrongAnswers(data.cheat.hint.optiontoRemove));
          dispatch(setShowCheatModal(false));
          dispatch(UsersRequests.getme());
        })
        .catch((error) => {
          errorHandler(error);
          setLoading(false);
        });
    } else if (selected === "third") {
      setLoading(true);
      appApi
        .post(`/quizCheat/create`, {
          type: "RightAnswer",
          questionId: currentQuestion?._id,
          ticketId: localStorage.getItem("Ticket"),
        })
        .then(({ data }) => {
          setLoading(false);
          toast.success(data.message);
          dispatch(setRightAnswer(data.hint.rightAnswer));
          dispatch(setShowCheatModal(false));
          dispatch(UsersRequests.getme());
        })
        .catch((error) => {
          errorHandler(error);
          setLoading(false);
        });
    }
  };

  const handleClose = () => {
    dispatch(setShowCheatModal(false));
  };

  const CheatDialogContent = (
    <div className="w-100 text-center">
      <img src={InfoImg} alt="check-vector" className={classes.alertBanner} />
      <p className={classes.smallTitle}>قدرت </p>
      <div className="d-flex align-items-center justify-content-center">
        <img src={KeyIcon} alt="keyIcon" className={classes.keyIconImg} />
        <p className="mb-0 mr-1">{currentUser?.coin}</p>
      </div>
      <div
        className={`${classes.cheatItem} ${
          selected === "first" ? classes.cheatItemSelected : ""
        }`}
        onClick={() => setselected("first")}
      >
        <div className="d-flex justify-content-between ">
          <div className="d-flex align-items-center">
            <GoStopwatch color="#6949FF" fontSize={"20px"} />
            <p className="mb-0 mr-1">خرید 1 دقیقه زمان</p>
          </div>
          <div className="d-flex align-items-center">
            <img src={KeyIcon} alt="keyIcon" className={classes.keyIconImg} />
            <p className="mb-0 mr-1">3</p>
          </div>
        </div>
      </div>
      {currentQuestion &&
        (currentQuestion?.type === "multipleChoice" ||
          currentQuestion?.type === "multipleImageChoice") && (
          <div
            className={`${classes.cheatItem} ${
              selected === "second" ? classes.cheatItemSelected : ""
            }`}
            onClick={() => setselected("second")}
          >
            <div className="d-flex justify-content-between ">
              <div className="d-flex align-items-center">
                <p className="mb-0 mr-1">حذف دو پاسخ غلط</p>
              </div>
              <div className="d-flex align-items-center">
                <img
                  src={KeyIcon}
                  alt="keyIcon"
                  className={classes.keyIconImg}
                />
                <p className="mb-0 mr-1">2</p>
              </div>
            </div>
          </div>
        )}
      {currentQuestion && currentQuestion?.type !== "file" && (
        <div
          className={`${classes.cheatItem} ${
            selected === "third" ? classes.cheatItemSelected : ""
          }`}
          onClick={() => setselected("third")}
        >
          <div className="d-flex justify-content-between ">
            <div className="d-flex align-items-center">
              <p className="mb-0 mr-1">نمایش پاسخ صحیح</p>
            </div>
            <div className="d-flex align-items-center">
              <img src={KeyIcon} alt="keyIcon" className={classes.keyIconImg} />
              <p className="mb-0 mr-1">7</p>
            </div>
          </div>
        </div>
      )}
      <div className="w-100 mt-4">
        {loading ? (
          <Loading
            className={"d-flex justify-content-center mt-4 mb-2"}
            size={30}
          />
        ) : (
          <>
            {selected && (
              <CustomButton
                clickHandler={handleBuyTime}
                styles={{
                  marginTop: "16px",
                  backgroundColor: "var(--secondary475)",
                }}
                text={"خرید"}
              />
            )}

            <CustomButton
              clickHandler={handleClose}
              styles={{
                marginBlock: "16px",
                backgroundColor: "var(--secondary475)",
              }}
              text={"بازگشت"}
            />
          </>
        )}
      </div>
    </div>
  );

  return (
    <CustomModal
      open={showCheatModal}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={CheatDialogContent}
    />
  );
}
